import Alpine from "alpinejs";
import Navigation from "../components/Navigation";

Alpine.data("Navigation", Navigation);
